import React, { useEffect } from 'react'
import { HeaderReimburse } from '../../../components/Header/HeaderReimburse'
import DataTable from 'react-data-table-component'
import { useState } from 'react'
import axios from 'axios'
import { Baseurl } from '../../../../Config/Baseurl'
import moment from 'moment'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import { Link } from 'react-router-dom'
import { MdEdit } from 'react-icons/md'

export const ViewReimburse = () => {
  useEffect(() => {
    var nav_item = document.getElementById('viewReimburse')
    nav_item.classList.add('navlinkactive')
  }, [])

  const [data, setData] = useState([])
  const email = localStorage.getItem('email')
  const getData = async () => {
    await axios
      .post(Baseurl.nodeLocal + 'request/getRequestByEmail', { email: email })
      .then((res) => {
        setData(res.data.data)
      })
      .catch((err) => {})
  }
  console.log(data)

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.transaction_id,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Employee Name',
      selector: (row) => {
        return (
          <Tippy content={row.payee_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.payee_name}
            </p>
          </Tippy>
        )
      },
      width: '150px',
    },

    {
      name: 'Employee Department',
      selector: (row) => {
        return (
          <Tippy content={row.dept_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.dept_name}
            </p>
          </Tippy>
        )
      },
      width: '180px',
    },

    {
      name: 'Paid Amount',
      selector: (row) => row.paid_amount,
    },
    {
      name: 'Payment Mode',
      selector: (row) => row.mode_name,
    },
    {
      name: 'Initiated Date',
      selector: (row) => {
        return moment(
          new Date(row.initiate_date).toISOString().split('T')[0],
        ).format('DD-MM-YYYY')
      },
    },
    {
      name: 'Status',
      selector: (row) => row.employee_status,
    },

    {
      name: 'Last Updated Date',
      selector: (row) => {
        if (
          row.last_updated_date === 'Pending' ||
          row.last_updated_date === ''
        ) {
          return <p className="mt-3">-</p>
        } else {
          return moment(
            new Date(row.last_updated_date).toISOString().split('T')[0],
          ).format('DD-MM-YYYY')
        }
      },
    },
    {
      name: 'Action',
      cell: (row) => {
        return (
          <>
            {/* to edit and delete request */}

            <Link to={'/edit-reimburse/' + row.transaction_id} className="link">
              <MdEdit className="editbtn" />
            </Link>
          </>
        )
      },
    },
  ]
  return (
    <div className="container p-3">
      <HeaderReimburse />
      <div className="mt-4 w-100 d-flex justify-content-start">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/add-reimburse" className="link text-primary">
                Home
              </Link>
            </li>

            <li className="breadcrumb-item active" aria-current="page">
              My Requests
            </li>
          </ol>
        </nav>
      </div>
      <div className="mt-2 w-100">
        <DataTable
          title="My Requests"
          columns={columns}
          data={data}
          pagination
          highlightOnHover
          fixedHeader
        />
      </div>
    </div>
  )
}
